module.exports = new __parcel__URL__("twitter.284d4bd4.svg").toString();